import { configureStore } from '@reduxjs/toolkit';
import authReducer from '../auth/authSlice';
import notifyReducer from '../auth/notify';
import routeReducer from '../pages/configuration/routeSlice';
import participantReducer from '../pages/configuration/participantSignupSlice';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    route: routeReducer,
    notify: notifyReducer,
    participant: participantReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
